<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="정책 그룹 적용" width="500px" @close="close()">
    <div slot="content">
      <w-common-obj-list ref="commonObjList" title="관리 대상 목록" type="physical" :checked-obj-list="ruleTargetDatas" selected-managetype-id="NMS" />
      <el-row class="title-bar">
        <div class="title-h4">정책</div>
      </el-row>
      <el-table-wrapper ref="ruleTable" :column-default="columnDefault" :data="ruleDatas" :columns="syslogRuleColumns" :pagination="false">
        <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId" />
        </template>
        <template slot-scope="scope" slot="rule-type">
          {{scope.row.clearRuleFlag === '0' ? "발생정책" : "해제정책"}}
        </template>
      </el-table-wrapper>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { cloneDeep, isEmpty, forEach, map, difference } from 'lodash';
import integratedSyslogSettingAPI from '@/api/settings/log/integrated-syslog-settings';
import msgUtils from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WCommonObjList from '@/components/table/CommonObjList';

export default {
  name: 'WSyslogRuleTargetPopup',
  props: {
    ruleDatas: Array,
    selectedNode: Object,
  },
  components: {
    WEventlevelCell,
    WCommonObjList,
  },
  data() {
    const syslogRuleColumns = [
      {
        prop: 'syslogRuleName',
        label: '정책 이름',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'syslogRuleDesc',
        label: '설명',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
    ];
    return {
      syslogRuleColumns,
      columnDefault,
      group: 'physics',
      ruleTargetDatas: [],
      ruleTargetOriginDatas: [],
    };
  },
  methods: {
    /**
     * 정책별 적용 대상 목록을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      const syslogRuleIds = [];
      forEach(this.ruleDatas, (item) => {
        syslogRuleIds.push(item.syslogRuleId);
      });
      integratedSyslogSettingAPI.getSyslogRuleTargets({ syslogRuleIds }).then((response) => {
        if (response.data.success) {
          this.ruleTargetDatas = cloneDeep(response.data.data);
          this.ruleTargetOriginDatas = cloneDeep(response.data.data);
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '적용 대상 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 정책별 적용 대상을 수정한다.(체크박스)
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      const checkedObjList = this.$refs.commonObjList.getSelectedObjList();
      if (isEmpty(checkedObjList)) {
        this.$message(msgUtils.getCustomMsgData('관리 대상을 선택해주세요.'));
        return;
      }
      const checkedObjIds = map(checkedObjList, 'objId');
      const originCheckedObjIds = map(this.ruleTargetOriginDatas, 'objId');

      const insertObjIds = difference(checkedObjIds, originCheckedObjIds);
      const deleteObjIds = difference(originCheckedObjIds, checkedObjIds);

      const syslogRuleIds = [];
      forEach(this.ruleDatas, (item) => {
        syslogRuleIds.push(item.syslogRuleId);
      });

      const params = {
        syslogRuleIds,
        addObjs: insertObjIds,
        deleteObjs: deleteObjIds,
      };

      integratedSyslogSettingAPI.updateSyslogRuleTargets(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.APPLY, '정책', response.data.success));
          this.$emit('load-data');
          this.clickClose();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.APPLY, '정책', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.APPLY, '정책', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.commonObjList.initData();
    },
    clickClose() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Syslog/popup/SyslogRuleTargetPopup.vue